export default __webpack_public_path__ + "static/media/detail_big_1_5.55256c88.png";